'use client';

import { useLocale } from '@/context/LocaleContext';
import { getPublicStrings } from '@/i18n/public';

export default function LocalizedTagline() {
  const locale = useLocale();
  const { footerTagline } = getPublicStrings(locale).footer;

  return <p className="text-white/60 text-sm leading-relaxed mb-6">{footerTagline}</p>;
}
